// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d6b51530","276":"ab3c47c6"}[chunkId] + ".chunk.js";
};